<div class="row align-items-center">
    <div *ngIf="!useInnerHtml" class="col-10">
        {{text}}
    </div>
    <div *ngIf="useInnerHtml" class="col-10">
        <div [innerHTML]="text"></div>
    </div>
    <div class="col-2">
        <button mat-button matSnackBarAction color="warn"
            (click)="snackBarRef.dismissWithAction()"><mat-icon>close</mat-icon></button>
    </div>
</div>